export enum WorkspaceTimezone {
    NEW_YORK = "America/New_York",
    CHICAGO = "America/Chicago",
    DENVER = "America/Denver",
    PHOENIX = "America/Phoenix",
    LOS_ANGELES = "America/Los_Angeles",
    ANCHORAGE = "America/Anchorage",
    ADAK = "America/Adak",
    HONOLULU = "Pacific/Honolulu",
    PUERTO_RICO = "America/Puerto_Rico",
    GUAM = "Pacific/Guam",
    PAGO_PAGO = "Pacific/Pago_Pago",
    UTC = "UTC",
}

// Existing workspaces predate the timezone selector and keep the legacy
// Pacific assumption.
export const DEFAULT_WORKSPACE_TIMEZONE = WorkspaceTimezone.LOS_ANGELES;

export const WORKSPACE_TIMEZONE_LABELS: Record<WorkspaceTimezone, string> = {
    [WorkspaceTimezone.NEW_YORK]: "Eastern Time",
    [WorkspaceTimezone.CHICAGO]: "Central Time",
    [WorkspaceTimezone.DENVER]: "Mountain Time",
    [WorkspaceTimezone.PHOENIX]: "Mountain Time - Arizona",
    [WorkspaceTimezone.LOS_ANGELES]: "Pacific Time",
    [WorkspaceTimezone.ANCHORAGE]: "Alaska Time",
    [WorkspaceTimezone.ADAK]: "Hawaii-Aleutian Time - Adak",
    [WorkspaceTimezone.HONOLULU]: "Hawaii Time",
    [WorkspaceTimezone.PUERTO_RICO]: "Puerto Rico",
    [WorkspaceTimezone.GUAM]: "Guam",
    [WorkspaceTimezone.PAGO_PAGO]: "Pago Pago",
    [WorkspaceTimezone.UTC]: "UTC",
};

const WORKSPACE_TIMEZONES = new Set<string>(Object.values(WorkspaceTimezone));

export function isWorkspaceTimezone(
    value: string | null | undefined,
): value is WorkspaceTimezone {
    return value != null && WORKSPACE_TIMEZONES.has(value);
}
